// extracted by mini-css-extract-plugin
export default {"primary":"#06bbcc","secondary":"#6c757d","light":"#f0fbfc","dark":"#181d38","text":"#52565b","success":"#198754"};